import RemoveButton from '../RemoveButton/RemoveButton'
import classes from './StatusChip.module.scss'
import {
  HiCheckCircle,
  HiClock,
  HiExclamation,
  HiExclamationCircle,
  HiLockClosed,
  HiMinusCircle,
  HiXCircle
} from 'react-icons/hi'
import {
  InProgressCircle,
  SkippedStatus,
  StateRerunDot
} from '../Icons/Icons'
import type {
  ConnectionStatus,
  EnvironmentStatus,
  RequirementStatusLabel,
  RequirementStatusVariant,
  RunStatusLabel,
  Status,
  SutStatus,
  TMIStatusLabel,
  TMIStatusVariant
} from '../types'
import type { ReactNode } from 'react'

export interface BaseProps {
  isParentMaxHeight?: boolean
  trailingIcon?: ReactNode
  onRemoveClick?: () => void
}

export interface StatusProps {
  variant: Status
  label: RunStatusLabel | EnvironmentStatus | SutStatus | ConnectionStatus
}

export interface RequiremntProps {
  variant: RequirementStatusVariant
  label: RequirementStatusLabel
}

export interface TMIProps {
  variant: TMIStatusVariant
  label: TMIStatusLabel
}

type Props = BaseProps & (StatusProps | RequiremntProps | TMIProps)

const iconMap: Record<Status | RequirementStatusVariant | TMIStatusVariant, any> = {
  fail: HiExclamationCircle,
  pass: HiCheckCircle,
  passAfterRerun: StateRerunDot,
  cancelled: HiXCircle,
  error: HiExclamation,
  inProgress: InProgressCircle,
  pending: HiClock,
  verified: HiCheckCircle,
  unsuccessful: HiExclamationCircle,
  untested: HiClock,
  unassigned: HiXCircle,
  ignore: HiMinusCircle,
  skipped: SkippedStatus,
  locked: HiLockClosed
}

const StatusChip = ({
  isParentMaxHeight = false,
  label,
  onRemoveClick,
  variant,
  trailingIcon
}: Props) => {
  const Icon = iconMap[variant]

  const parentMaxHeightClass = isParentMaxHeight
    ? classes.isParentMaxHeight
    : ''

  const styleClasses = [
    classes.StatusChip,
    parentMaxHeightClass,
    classes[variant]
  ].filter(style => style).join(' ')

  return (
    <span className={styleClasses}>
      <span className={classes.iconColor}>
        <Icon
          aria-hidden
          size={18}
        />
      </span>
      <span>{label}</span>
      {
        trailingIcon &&
          <>
            <div className={classes.Divider} />
            {trailingIcon}
          </>
      }
      {onRemoveClick && <RemoveButton onClick={onRemoveClick} />}
    </span>
  )
}

export default StatusChip
